<template>
  <div>
    <b-form-select
      @change="showConfirmation(value,$event)"
      :disabled="!editClaim||value=='refunded'||(session.role != 'claim' && session.role != 'claim_manager' && session.role != 'superadmin')||(session.role == 'claim' && !isUserProcessedBy)"
      :value="value"
      class="my-0"
      :class="value === 'submitted' ? 'text-warning':'' || value === 'on_review' ? 'text-info':''|| value === 'refunded' ? 'text-primary':''|| value === 'rejected' ? 'text-danger':'' "
      id="input-1"
    >
      <option
        value="submitted"
        :class="isSubmittedDisabled ? '' : 'text-warning'"
        :disabled="isSubmittedDisabled"
      >Submitted - Permintaan klaim kamu sudah diterima</option>
      <option
        value="on_review"
        :class="isOnReviewDisabled ? '' : 'text-info'"
        :disabled="isOnReviewDisabled"
      >On Review - Permintaan klaim kamu sedang diproses</option>
      <option
        value="refunded"
        :class="isRefundedDisabled ? '' : 'text-primary'"
        :disabled="isRefundedDisabled"
      >Refunded - Proses klaim kamu sudah selesai, silahkan cek rek..</option>
      <option
        value="rejected"
        :class="isRejectedDisabled ? '' : 'text-danger'"
        :disabled="isRejectedDisabled"
      >Rejected - Mohon maaf permintaan kamu ditolak</option>
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: ["value", "editClaim", "rejectReasonValue", "rejectReasons", "isUserProcessedBy"],
  data: function() {
    return {
      unconfirmedValue: "",
      session: this.$session.get("jwt")
    };
  },
  computed: {
    isSubmittedDisabled() {
      return ["on_review", "refunded", "rejected"].includes(this.value);
    },
    isOnReviewDisabled() {
      return ["refunded", "rejected"].includes(this.value);
    },
    isRefundedDisabled() {
      return ["rejected"].includes(this.value);
    },
    isRejectedDisabled() {
      return ["refunded"].includes(this.value);
    },
  },
  methods: {
    refresh() {
      this.$store.dispatch("cxModule/getCxReport", this.$route.params.id);
    },
    showConfirmation(newValue, e) {
      this.unconfirmedValue = e;
      const oldValue = this.value;
      if (e == "refunded") {
        this.$swal({
          title: "Yakin Ubah Status Refunded??",
          text: "Status tidak akan bisa diubah lagi setelah ini",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!"
        }).then(result => {
          if (result.value) {
            this.loading = true;
            const statusData = {
              status: e
            };
            this.$store
              .dispatch("cxModule/putCxStatus", {
                id: this.$route.params.id,
                statusData
              })
              .then(response => {
                this.loading = false;
                this.refresh();
                this.$swal({
                  title: "Change!",
                  text: "Your status has been change.",
                  type: "success",
                  showConfirmButton: false,
                  timer: 1000
                });
                this.value = e;
                console.log(response);
              })
              .catch(error => {
                this.loading = false;
                this.serverError = error.response;
                console.log(error);
              });
          } else {
            this.refresh();
            this.value = undefined;
          }
        });
      } else if (e === "rejected") {
        let options = {};
        this.rejectReasons.forEach(item => options[item.id] = item.description);
        this.$swal({
          title: "Yakin Ubah Status Rejected??",
          type: "warning",
          input: 'select',
          inputOptions: options,
          inputPlaceholder: 'Pilih alasan...',
          inputValue: this.rejectReasonValue ? this.rejectReasonValue : '',
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
          onOpen: () => {
            this.$swal.getConfirmButton().setAttribute('disabled', 'disabled');
            const input = this.$swal.getInput();
            input.oninput = () => {
              this.$swal.getConfirmButton().removeAttribute('disabled');
            };
          },
        }).then((result) => {
          if (result.value) {
            const rejectReasonId = result.value;
            if (rejectReasonId == "6234748314f475794ec8808c") {
              this.$swal({
                title: "Please fill others reject value",
                type: "warning",
                input: 'text',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
                onOpen: () => {
                  this.$swal.getConfirmButton().setAttribute('disabled', 'disabled');
                  const input = this.$swal.getInput();
                  input.oninput = () => {
                    this.$swal.getConfirmButton().removeAttribute('disabled');
                  };
                },
              }).then((result) => {
                console.log(result);
                if (result.value) {
                  this.loading = true;
                  const statusData = {
                    status: e,
                    reject_reason_id: rejectReasonId,
                    reject_reason_other: result.value,
                  };
                  this.$store
                    .dispatch("cxFoodClaim/putCxStatus", {
                      id: this.$route.params.id,
                      statusData,
                    })
                    .then((response) => {
                      this.loading = false;
                      this.refresh();
                      this.$swal({
                        title: "Change!",
                        text: "Your status has been change.",
                        type: "success",
                        showConfirmButton: false,
                        timer: 1000,
                      });
                      this.value = e;
                      console.log(response);
                    })
                    .catch((error) => {
                      this.loading = false;
                      this.serverError = error.response;
                      this.$swal({
                        type: "error",
                        title: "Something wrong!",
                        text: error.response.data.data || error.message,
                        showConfirmButton: false,
                        timer: 3000,
                      });
                    });
                } else {
                  this.refresh();
                  this.value = undefined;
                }
              });
            } else {
              this.loading = true;
              const statusData = {
                status: e,
                reject_reason_id: result.value,
              };
              this.$store
                .dispatch("cxModule/putCxStatus", {
                  id: this.$route.params.id,
                  statusData,
                })
                .then((response) => {
                  this.loading = false;
                  this.refresh();
                  this.$swal({
                    title: "Change!",
                    text: "Your status has been change.",
                    type: "success",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.value = e;
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.serverError = error.response;
                  this.$swal({
                    type: "error",
                    title: "Something wrong!",
                    text: error.response.data.data || error.message,
                    showConfirmButton: false,
                    timer: 3000,
                  });
                });
            }
          } else {
            this.refresh();
            this.value = undefined;
          }
        });
      } else {
        this.$swal({
          title: "Ubah Status Claim??",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!"
        }).then(result => {
          if (result.value) {
            this.loading = true;
            const statusData = {
              status: e
            };
            this.$store
              .dispatch("cxModule/putCxStatus", {
                id: this.$route.params.id,
                statusData
              })
              .then(response => {
                this.loading = false;
                this.refresh();
                this.$swal({
                  title: "Change!",
                  text: "Your status has been change.",
                  type: "success",
                  showConfirmButton: false,
                  timer: 1000
                });
                this.value = e;
                console.log(response);
              })
              .catch(error => {
                this.loading = false;
                this.serverError = error.response;
                console.log(error);
              });
          } else {
            this.refresh();
            this.value = undefined;
          }
        });
      }
    }
  }
};
</script>

<style>
</style>